import { connect } from 'react-redux';
import Nav from '../components/nav.js';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { logout } from '../../../modules/admin';

import '../dashboard.scss';

export class Layout extends Component {
  constructor(props) {
    super(props)

    this.state = {
      width: window.innerWidth,
      isOpen: window.innerWidth > 800 ? true : false,
      showText: window.innerWidth > 800 ? true : false
    }
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (window.innerWidth <= 800 && this.state.isOpen) {
      this.setOpen()
    }
    this.setState({ width: window.innerWidth });
  }

  setOpen = () => {
    if (!this.state.showText) {
      this.setState({ isOpen: !this.state.isOpen })
      setTimeout(() => {
        this.setState({ showText: !this.state.showText })
      }, 300)
    } else {
      this.setState({ isOpen: !this.state.isOpen, showText: !this.state.showText })
    }
  }

  render() {
    const { setOpen } = this;
    const { isOpen, showText } = this.state;
    const { admin, Component, ...props } = this.props;

    return (
      <div className="layout">
        <Nav admin={admin} {...props} setOpen={setOpen} isOpen={isOpen} showText={showText} logout={this.props.logout}/>
        <Component isOpen={isOpen} />
      </div>
    )
  }
}

const mapStateToProps = ({ admin }) => ({
  admin: admin.user
})

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout)
